import { useTranslation } from "react-i18next";
// src/pages/RecognitionCenter.tsx
import React from "react";
import { Outlet } from "react-router-dom";

import SectionShell, {
  type SectionTab,
} from "../components/layout/SectionShell";

export default function RecognitionCenter() {
  const { t } = useTranslation();
  const spendingTabs: SectionTab[] = [
    {
      label: t("expenses.common.expenses"),
      to: "/recognition/expenses",
      end: true,
    },
    {
      label: t("expenses.tabs.prepaids"),
      to: "/recognition/prepaids",
      end: true,
    },
    {
      label: t("expenses.tabs.deposits"),
      to: "/recognition/deposits",
      end: true,
    },
    {
      label: t("expenses.tabs.fixedAssets"),
      to: "/recognition/fixed-assets",
      end: true,
    },
  ];

  return (
    <SectionShell
      title={t("navigation.spending")}
      tabs={spendingTabs}
      tabsAriaLabel={t("expenses.tabs.aria")}
      backLabel={t("directory.common.back")}
      closeLabel={t("directory.common.close")}
      closePath="/"
    >
      <Outlet />
    </SectionShell>
  );
}